import { Box, useToken } from '@chakra-ui/react';
import useUserAybleScores from '../../../api/healthCoach/useUserAybleScores';
import {
  computeOverTimeScore,
  computeScoreTrend,
  computeTodayScore,
  formatScore,
} from '../../../utils/scores';
import { Trend } from '../../../models/score';
import TrendingIconUpSVG from '../../CustomSVGs/TrendingIconUpSVG';
import TrendingIconDownSVG from '../../CustomSVGs/TrendingIconDownSVG';
import { ChevronRight } from 'lucide-react';
import OverviewCard from './OverviewCard';

type Props = {
  onClick?: () => void;
};

const SymptomScoreCard = ({ onClick }: Props) => {
  const [seafoam] = useToken('colors', ['seafoam']);

  const { aybleScores, isLoading } = useUserAybleScores();
  const overTimeScore = formatScore(computeOverTimeScore(aybleScores));
  const todayScore = formatScore(computeTodayScore(aybleScores));
  const scoreTrend = computeScoreTrend(overTimeScore, todayScore);

  const TrendIcon =
    scoreTrend === Trend.up ? TrendingIconUpSVG : TrendingIconDownSVG;

  return (
    <OverviewCard
      title={'Symptom Change'}
      text={overTimeScore}
      icon={
        <Box
          rounded={'full'}
          background="linear-gradient(63deg, #FFD966 0.01%, #FEB117 83.34%)"
          p={3}
        >
          <TrendIcon height={8} width={8} />
        </Box>
      }
      bottomTag={{
        text: 'Over the last month',
        icon: <ChevronRight color={seafoam} size={16} />,
        onClick,
      }}
      loading={isLoading}
      h={'120px'}
    />
  );
};

export default SymptomScoreCard;
